import { Component, effect, inject, input, model, output } from '@angular/core';
import { rxResource } from '@angular/core/rxjs-interop';

import { of } from 'rxjs';

import { CustomerService } from '../../../services/customer';

@Component({
  selector: 'fs-contract-select',
  templateUrl: './contract-select.html',
  styleUrl: './contract-select.scss'
})
export class ContractSelect {
  private readonly customerService = inject(CustomerService);

  readonly value = model<string>('');
  readonly touch = output<void>();

  readonly disabled = input<boolean>(true);
  readonly company = input<string>('');

  readonly contractsResource = rxResource({
    params: () => this.company(),
    stream: ({ params }) => params!=""?this.customerService.getCompanyIdListAllContract(params):of([])
  });

  constructor() {
    effect(() => {
      const company = this.company();
      if (!company) this.value.set('');
    });
  }

  onSelectionChange(event: Event) {
    const target = event.target as HTMLSelectElement;
    this.value.set(target.value);
  }
}